var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
// https://react-spectrum.adobe.com/react-aria/useTabList.html
import { useTabList, useTab, useTabPanel } from 'react-aria';
import { Item, useTabListState } from 'react-stately';
import './tablist.scss';
function Tabs(props) {
    var _a;
    const state = useTabListState(props);
    const ref = React.useRef(null);
    const { tabListProps } = useTabList(props, state, ref);
    return (React.createElement("div", { className: `tabs ${props.orientation || ''}` },
        React.createElement("div", Object.assign({}, tabListProps, { ref: ref }), [...state.collection].map((item) => (React.createElement(Tab, { key: item.key, item: item, state: state })))),
        React.createElement(TabPanel, { key: (_a = state.selectedItem) === null || _a === void 0 ? void 0 : _a.key, state: state })));
}
function Tab({ item, state }) {
    const { key, rendered } = item;
    const ref = React.useRef(null);
    const { tabProps } = useTab({ key }, state, ref);
    return (React.createElement("div", Object.assign({}, tabProps, { ref: ref }), rendered));
}
function TabPanel(_a) {
    var _b;
    var { state } = _a, props = __rest(_a, ["state"]);
    const ref = React.useRef(null);
    const { tabPanelProps } = useTabPanel(props, state, ref);
    return (React.createElement("div", Object.assign({}, tabPanelProps, { ref: ref }), (_b = state === null || state === void 0 ? void 0 : state.selectedItem) === null || _b === void 0 ? void 0 : _b.props.children));
}
export { Item, Tabs };
